import * as React from 'react';
const OptionCardContentCore = (props) => {
    const { CardContent } = props.components;
    const BEM = () => {
        const classArray = ['option-card__content'];
        if (props.color) {
            classArray.push(`option-card__content--${props.color}`);
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    return (React.createElement(CardContent, Object.assign({}, props, { className: BEM() }), props.children));
};
export default OptionCardContentCore;
